import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/login.vue'
import SignUp from '../views/signup.vue'
import ForgotPass from '../views/forgot-pass.vue'
import index from '../components'


import Dashboard from "../pages/dashboard";
import Fixtures from "../pages/fixtures/index";
import Prediction from "../pages/predictions/index";
import AddPrediction from "../pages/predictions/add";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/signup', name: 'signup', component: SignUp, meta: { guest: true } },
        { path: '/forgot-password', name: 'forgot', component: ForgotPass, meta: { guest: true } },
        { path: '/login', name: 'login', component: Login, meta: { guest: true }
        },
        {
            path: '/',
            component: index,
            children: [
                { path: '', name: 'dashboard', component: Dashboard, meta: { permission: 'Read Statistics', requiresAuth: true }},
                { path: 'fixtures', name: 'fixtures', component: Fixtures, meta: { permission: 'Transactions', requiresAuth: true }},
                { path: 'prediction', name: 'prediction', component: Prediction, meta: { permission: 'Transactions', requiresAuth: true }},
                { path: 'prediction/add', name: 'add-prediction', component: AddPrediction, meta: { permission: 'Transactions', requiresAuth: true }},
            ]
        },
    ]
})


/*
router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        next("/");
    } else {
        next();
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.guest)) {
        if (store.getters.isAuthenticated) {
            next("/app/");
            return;
        }
        next();
    } else {
        next();
    }
});
*/


export default router
